import e from "react";
import { getIconColor as r } from "./iconfont.es5470.js";
import x from "./iconfont.es5471.js";
const d = {
  display: "block"
}, f = ({ size: a = 16, useVw: o, useRem: t, color: l, withColor: c, removeClassName: n, disableSSR: g, style: i, ...m }) => {
  const p = i ? { ...d, ...i } : d;
  return /* @__PURE__ */ e.createElement(x, { disableSSR: g }, /* @__PURE__ */ e.createElement("svg", { "data-icon-id": "24px-gonggaozhongxin", "data-icon-group": "GateHeader", "data-icon-version": "0.8.1", viewBox: "0 0 24 24", width: o ? ((a || 0) / 375 * 100).toFixed(5) + "vw" : a + (t ? "rem" : "px"), height: o ? ((a || 0) / 375 * 100).toFixed(5) + "vw" : a + (t ? "rem" : "px"), className: n ? "" : "iconpark-icon", style: p, fill: "none", ...m }, /* @__PURE__ */ e.createElement(
    "g",
    {
      className: n ? "" : "24px-å¬åä¸­å¿"
    },
    /* @__PURE__ */ e.createElement(
      "g",
      {
        className: n ? "" : "normal",
        fill: c ? r(l, 0, "#262933") : "#262933",
        datafollowfill: c ? r(l, 0, "#262933") : "#262933"
      },
      /* @__PURE__ */ e.createElement(
        "path",
        {
          clipRule: "evenodd",
          d: "M15.037 4.095a1.599 1.599 0 0 0-2.403-1.382L7.163 5.895a1.735 1.735 0 0 1-.872.236H4.098A2.398 2.398 0 0 0 1.7 8.528v6.944a2.398 2.398 0 0 0 2.398 2.397h2.193c.306 0 .607.082.872.236l5.471 3.182a1.599 1.599 0 0 0 2.403-1.382V4.095Zm-7.07 3.183 5.47-3.181v15.806l-5.47-3.181a3.334 3.334 0 0 0-1.676-.453H4.098a.798.798 0 0 1-.798-.797V8.527c0-.44.357-.797.798-.797h2.193c.589 0 1.167-.156 1.676-.453Z",
          fillRule: "evenodd"
        }
      ),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M19.75 5.842a.8.8 0 0 0-1.132 1.131 7.109 7.109 0 0 1 0 10.054.8.8 0 1 0 1.131 1.131 8.709 8.709 0 0 0 0-12.316Z"
        }
      )
    )
  )));
}, s = f;
export {
  s as default
};
